<!--template>
  <v-list v-if="menu && menu.length">
    {{menu.length}}
    <v-list-item v-for="(item, index) in menu" :key="index" class="menu-item" :style="{ color: 'inherit !important' }">
      <Message style="width: 100%" :value="getAction(item)" @input="sendMessage($event); onClick()" />

      <Navigation v-if="item.type === 'nested'" :menu="item.menu" @click="onClick" :style="{ color: 'inherit', backgroundColor: 'inherit' }" />
    </v-list-item>
  </v-list>
</template-->

<!--
    this.$emit('input', new Text(this.value.message));
-->


<template>
  <v-list v-if="menu && menu.length">
    <v-list-item-group>

      <v-list-item v-for="(item, index) in items" :key="index"
        class="menu-item"
        @click=" item.type === 'text' ? (sendMessage(item.title), onClick()) : selectNested(item.type, item.title, item.url) "

      >

        <template v-if="item.type === 'backClose'">
          <div class="bloc-list-item">
          <v-list-item-icon>
            <v-icon dark v-text="mdiChevronLeft"></v-icon>
          </v-list-item-icon>

          <v-list-item-title class="white--text" v-text="item.title"></v-list-item-title>

          <v-list-item-icon>
            <v-icon dark v-text="mdiClose" @click.prevent="onClick()"></v-icon>
          </v-list-item-icon>
          </div>
        </template>

        <template v-if="item.type === 'close'">
          <div class="bloc-list-item">

          <v-list-item-title class="white--text" v-text="item.title" @click="onClick()"></v-list-item-title>

          <v-list-item-icon>
            <v-icon dark v-text="mdiClose"></v-icon>
          </v-list-item-icon>
          </div>
        </template>

        <template v-if="item.type === 'nested'">
          <div class="bloc-list-item">
          <v-list-item-title class="white--text" v-text="item.title"></v-list-item-title>

          <v-list-item-icon>
            <v-icon dark v-text="mdiChevronRight"></v-icon>
          </v-list-item-icon>
          </div>
        </template>

        <template v-if="item.type === 'text'">
          <v-list-item-title class="white--text" v-text="item.title" ></v-list-item-title>
        </template>

        <template v-if="item.type === 'url'">
          <v-list-item-title class="white--text" v-text="item.title" ></v-list-item-title>
        </template>

      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { TextType, UrlType, ButtonType } from 'components-system';
import { mdiChevronRight, mdiChevronLeft, mdiClose } from '@mdi/js';

export default {
  name: 'Navigation',
  props: {
    menu: {
      type: Array,
    },
  },
  data: () => ({
    selectedItem: -1,
    current: [],
    mdiChevronRight,
    mdiChevronLeft,
    mdiClose
  }),
  computed: {
    // show menu items
    items() {
      // if root menu

      if (this.current.length === 0) {
        let arrHeader = [{
          'title': 'Close Menu',
          'type': 'close'
        }]

        let arrContent = this.menu.map(e => ( e.url ? {
          'title': e.title,
          'type': e.type,
          'url': e.url
        } : {
          'title': e.title,
          'type': e.type
        }));

        return [...arrHeader, ...arrContent];

      // if inner menu
      } else {

        let arrHeader = [{
          'title': this.current[this.current.length - 1],
          'type': 'backClose'
        }]

        let way = this.menu;

        for (let title of this.current) {
          way = way.find(e => e.title === title).menu;
        }

        let arrContent = way.map(e => (e.url ? {
          'title': e.title,
          'type': e.type,
          'url': e.url
        } : {
          'title': e.title,
          'type': e.type
        }));

        return [...arrHeader, ...arrContent];
      }
    },
  },
  methods: {
    selectNested(type, title, url) {
      if (type === 'nested') {
        this.current.push(title);
      } else if (type === 'backClose') {
        this.current.pop();
      } else if (type === 'close') {
        this.onClick();
      } else if (type === 'url') {
        this.onClick()
        window.open(url)
      }
    },
    sendMessage(value) {
      if (value.type === 'webview') {
        this.$root.$emit('show:webview', value);
      } else {
        // this.$store.dispatch('chatFlow/send', value);
        this.$store.dispatch('chatFlow/send', new TextType(value));
      }
    },
    onClick() {
      this.$emit('click');
    },
    getAction(item) {
      console.log("==> ", item, item.type, UrlType.type)

      switch (item.type) {
        case UrlType.type: {
          return new UrlType({
            url: item.url,
            title: item.title
          });
        }
        case TextType.type:
        default: {
          return new ButtonType(item.title);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.menu-item {
  padding: 0 20px !important;
  max-height: 48px;

  .v-btn {
    width: 100%;
    background-color: transparent !important;
    box-shadow: none;
    border-radius: 0;
    justify-content: start;
  }

  .v-btn__content {
    justify-content: flex-start;
  }
}
.bloc-list-item{
  display: flex;
    width: 100%;
}
.v-menu__content {
  position: fixed;
  min-width: 100% !important;
  left: 0 !important;
  right: 0;
  bottom: 0;
  display: flex !important;
  flex-direction: column-reverse;
  height: auto;
}

.v-list {
  position: fixed !important;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding: 0 !important;


  .menu-item {
    color: white !important;
  }

  .v-list-item--link:before{
    content: none;
}
  // .white--text{
  //   font-size: 14px !important;
  // }
}
</style>
